import { useState, useEffect } from "react";

const ErrorMessages = ({
  err = "Transaction failed. Something went wrong.",
  returnUrl,
}) => {
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (!returnUrl) return; // Only start timer if returnUrl exists

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.replace(returnUrl);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [returnUrl]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 overflow-hidden relative px-4 sm:px-6 md:px-8">
      {/* Subtle background glow */}
      <div className="absolute inset-0">
        <div className="absolute -top-32 -left-32 w-72 h-72 bg-indigo-400/20 blur-3xl rounded-full" />
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-purple-400/20 blur-3xl rounded-full" />
      </div>

      {/* Card */}
      <div className="relative w-full max-w-sm sm:max-w-md md:max-w-lg bg-white/70 backdrop-blur-xl shadow-2xl rounded-3xl p-8 sm:p-10 text-center border border-white/40 overflow-hidden">
        {/* Inner glow overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-400/10 to-purple-400/10 pointer-events-none"></div>

        {/* Icon */}
        <div className="relative mx-auto w-16 h-16 sm:w-18 sm:h-18 flex items-center justify-center rounded-full bg-gradient-to-tr from-indigo-500 to-purple-500 mb-6 shadow-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01M21 12A9 9 0 113 12a9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Title */}
        <h2 className="relative text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-2">
          Transaction Not Completed!
        </h2>

        {/* Message */}
        <p className="relative text-gray-600 text-sm sm:text-base leading-relaxed break-words">
          {err ||
            "Something went wrong while processing your payment. Please try again later."}
        </p>

        {/* Countdown */}
        {returnUrl && countdown > 0 && (
          <p className="relative mt-4 text-gray-500 text-sm sm:text-base">
            Redirecting in{" "}
            <span className="font-semibold text-gray-700">{countdown}</span>{" "}
            second{countdown !== 1 ? "s" : ""}...
          </p>
        )}

        {/* Back to Merchant button */}
        <button
          onClick={() =>
            returnUrl
              ? window.location.replace(returnUrl)
              : window.location.reload()
          }
          className="relative mt-8 inline-flex items-center justify-center px-6 py-2.5 bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white font-semibold rounded-full shadow-md transition-all duration-300 text-sm sm:text-base"
        >
          Back to Merchant
        </button>
      </div>
    </div>
  );
};

export default ErrorMessages;
